/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, actions: NonNullable<unknown> }} Seo_Title_PlatformInputs */

const en_seo_title_platform = /** @type {(inputs: Seo_Title_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} API - scrape ${i?.actions}`)
};

const zh_hans1_seo_title_platform = /** @type {(inputs: Seo_Title_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 数据抓取 API：${i?.actions}`)
};

const pt_br2_seo_title_platform = /** @type {(inputs: Seo_Title_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API de scraping para ${i?.name}: ${i?.actions}`)
};

const es_seo_title_platform = /** @type {(inputs: Seo_Title_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API de scraping de ${i?.name}: ${i?.actions}`)
};

const fr_seo_title_platform = /** @type {(inputs: Seo_Title_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API ${i?.name} - scraping de ${i?.actions}`)
};

const de_seo_title_platform = /** @type {(inputs: Seo_Title_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}-API: ${i?.actions} scrapen`)
};

const ru_seo_title_platform = /** @type {(inputs: Seo_Title_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API ${i?.name} - скрапинг: ${i?.actions}`)
};

const it_seo_title_platform = /** @type {(inputs: Seo_Title_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`API ${i?.name} - scraping di ${i?.actions}`)
};

/**
* | output |
* | --- |
* | "{name} API - scrape {actions}" |
*
* @param {Seo_Title_PlatformInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_title_platform = /** @type {((inputs: Seo_Title_PlatformInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Title_PlatformInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_title_platform(inputs)
	if (locale === "pt-BR") return pt_br2_seo_title_platform(inputs)
	if (locale === "es") return es_seo_title_platform(inputs)
	if (locale === "fr") return fr_seo_title_platform(inputs)
	if (locale === "de") return de_seo_title_platform(inputs)
	if (locale === "ru") return ru_seo_title_platform(inputs)
	if (locale === "it") return it_seo_title_platform(inputs)
	return en_seo_title_platform(inputs)
});